import { Options } from "highcharts";
import { axisLabelFormatter } from "./formatters/axisLabelFormatter";
import { tooltipFormatter } from "./formatters/tooltipFormatter";
import { BucketSizeItem } from "./mocks";

const RANGE_TO_DAYS: Record<string, number> = {
  "1D": 1,
  "1W": 7,
  "1M": 30,
  "3M": 90,
};

export const mapToChartData = (data: BucketSizeItem[]): [number, number][] =>
  data.map((item) => [new Date(item.dateTime).getTime(), item.bucketSize]);

export const makeChartOptions = (data: [number, number][]): Options => ({
  chart: {
    type: "line",
    height: 260,
    backgroundColor: "transparent",
    spacingTop: 8,
    spacingRight: 8,
    spacingBottom: 0,
    spacingLeft: 0,
    style: {
      fontFamily: "Dustin Sans",
    },
  },
  title: {
    text: undefined,
  },
  xAxis: {
    type: "datetime",
    tickInterval: 30 * 24 * 3600 * 1000,
    labels: {
      format: "{value:%b}",
      style: {
        color: "#8c8c8c",
        fontSize: "12px",
      },
    },
    lineWidth: 1,
    lineColor: "#bdbdbd",
    tickColor: "#bdbdbd",
  },
  yAxis: {
    title: undefined,
    gridLineColor: "#d9d9d9",
    gridLineWidth: 1,
    gridLineDashStyle: "Dash",
    labels: {
      formatter: axisLabelFormatter,
    },
  },
  tooltip: {
    formatter: tooltipFormatter,
  },
  plotOptions: {
    series: {
      marker: {
        enabled: false,
      },
      lineWidth: 2,
    },
  },
  series: [
    {
      type: "line",
      name: "Bucket size",
      data,
      color: "#c084fc",
    },
  ],
  legend: {
    enabled: false,
  },
  credits: {
    enabled: false,
  },
});

export const filterByRange = (data: BucketSizeItem[], range: string): BucketSizeItem[] => {
  const days = RANGE_TO_DAYS[range];

  if (!days || !data.length) return data;

  const timestamps = data.map((item) => new Date(item.dateTime).getTime());
  const maxTimestamp = Math.max(...timestamps);

  const toDate = new Date(maxTimestamp);
  const fromDate = new Date(maxTimestamp);
  fromDate.setDate(fromDate.getDate() - days);

  return data.filter((item) => {
    const itemDate = new Date(item.dateTime);
    return itemDate >= fromDate && itemDate <= toDate;
  });
};
